import BaseService from './core/base.service';
import { SERVICE_NAMES } from './core/service-names';

class MedicationRemindersService extends BaseService {
  async find() {
    const response = await this.repository.find();
    return this.handleResponse(response);
  }

  async create(request) {
    const response = await this.repository.create(request);
    return this.handleResponse(response);
  }

  async update(itemUnique, request) {
    const response = await this.repository.update(itemUnique, request);
    return this.handleResponse(response);
  }

  async remove(itemUnique) {
    const response = await this.repository.remove(itemUnique);
    return this.handleResponse(response);
  }

  async respond(itemUnique, request) {
    const response = await this.repository.respond(itemUnique, request);
    return this.handleResponse(response);
  }
}

export default new MedicationRemindersService(SERVICE_NAMES.MEDICATION_REMINDERS);
